// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32fAJ","left":"styles_left__1V6TJ","desktopActions":"styles_desktopActions__3KX6x","title":"styles_title__1ycOK"};